import { valid, compare } from 'semver';

export const sort = (arr: string[]): string[] =>
  arr.sort((a, b) => {
    if (valid(a) && valid(b)) {
      return compare(a, b);
    }
    if (valid(a)) {
      return 1;
    }
    if (valid(b)) {
      return -1;
    }
    return a.localeCompare(b);
  }).reverse();
